import type { GroupDetail } from 'models';
import { Card, HierarchyTreeCard, SiteMapLineIcon } from 'ui';
import { useGetHierarchyTreeItems } from './hooks';

type P = {
  getPathToGroupDetail: (id: string) => string;
  group: GroupDetail;
};
const GroupHierarchyCard = ({ getPathToGroupDetail, group }: P) => {
  const items = useGetHierarchyTreeItems({ getPathToGroupDetail, group });

  if (items.length === 0) {
    return null;
  }

  return (
    <HierarchyTreeCard card={{ title: <Card.Title icon={<SiteMapLineIcon />}>Hierarchy</Card.Title> }} items={items} />
  );
};

export default GroupHierarchyCard;
